var map = {
	"./project/astrapay.webp": "3da6",
	"./project/bankbri.webp": "6c2a",
	"./project/bestagro.webp": "3d98",
	"./project/btpns.webp": "fc5a",
	"./project/gorrywell.webp": "d10d",
	"./project/gotoko.webp": "17e7",
	"./project/gradana.webp": "942d",
	"./project/prakerja.webp": "8912",
	"./project/smartfren.webp": "62f3",
	"./project/telkom.webp": "3e38",
	"./project/telkomsat.webp": "3b95",
	"./project/tips.webp": "c198",
	"./project/travymeal.webp": "e78c",
	"./project/voy.webp": "012f",
	"./talent/astrapay.webp": "93dd",
	"./talent/btpns.webp": "25f2",
	"./talent/dana.webp": "f429",
	"./talent/danamas.webp": "9a1a",
	"./talent/doku.webp": "012a",
	"./talent/fif.webp": "2d16",
	"./talent/gotoko.webp": "bc5a",
	"./talent/telkomsat.webp": "f32f",
	"./training/antv.webp": "a382",
	"./training/astrapay.webp": "61da",
	"./training/baf.webp": "681d",
	"./training/bankbri.webp": "52d8",
	"./training/bankjatim.webp": "df53",
	"./training/bestagro.webp": "ee8c",
	"./training/btpns.webp": "b91a",
	"./training/cpprima.webp": "c4d5",
	"./training/dana.webp": "ec07",
	"./training/faspay.webp": "48bb",
	"./training/indosat.webp": "f6d0",
	"./training/manulife.webp": "a4ad",
	"./training/megalife.webp": "4a32",
	"./training/nexsoft.webp": "a11c",
	"./training/prakerja.webp": "2043",
	"./training/ptpp.webp": "d2b5",
	"./training/softorb.webp": "aac8",
	"./training/telkomsat.webp": "26b7",
	"./training/xlaxiata.webp": "125d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1b7";